// ---------------------------------------------------------------------------
// Estágio 1 — pedir o código de redefinição.
//
// ⚠️ A resposta do backend é DELIBERADAMENTE cega (0098 §2): 200 idêntico para
// e-mail cadastrado, desconhecido, ou quando o envio falha. Esta tela NUNCA
// pode dizer "e-mail não encontrado" — seria um oráculo de quais e-mails têm
// conta. O avanço para o estágio 2 é incondicional.
// ---------------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';

import FormField from '../../../../components/Form/FormField';
import { AuthForm } from '../../../../styles/auth/AuthLayout';
import { CtaButton } from '../../../../styles/ui/Button';
import { TextLink } from '../../../../styles/ui/Link';
import { FormFoot } from '../styled';

export default function EmailStage({
   email,
   onEmailChange,
   onSubmit,
   error,
   isSubmitting,
}) {
   return (
      <AuthForm onSubmit={onSubmit} noValidate>
         <FormField
            label="E-mail"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="Digite o e-mail da sua conta"
            value={email}
            onChange={onEmailChange}
            error={error}
            hint="Enviaremos um código de 6 dígitos para este endereço."
            disabled={isSubmitting}
            autoFocus
         />

         <FormFoot>
            <TextLink to="/login">Voltar para o login</TextLink>

            {/* Pedir o código não altera nada na conta (a senha atual segue
                valendo) → não é escrita: CTA escuro, não azul (FC7 §G.1). */}
            <CtaButton type="submit" disabled={isSubmitting}>
               {isSubmitting ? 'Enviando...' : 'Enviar código'}
            </CtaButton>
         </FormFoot>
      </AuthForm>
   );
}

EmailStage.propTypes = {
   email: PropTypes.string.isRequired,
   onEmailChange: PropTypes.func.isRequired,
   onSubmit: PropTypes.func.isRequired,
   error: PropTypes.string,
   isSubmitting: PropTypes.bool,
};

EmailStage.defaultProps = {
   error: null,
   isSubmitting: false,
};
